// API Configuration
// Automatically uses the same domain as the frontend for API calls
// Works for both Preview and Live environments

const getBackendUrl = () => {
  // If REACT_APP_BACKEND_URL is set and not empty, use it
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (envUrl && envUrl.trim() !== '') {
    return envUrl;
  }
  
  // Otherwise, use the same domain as the frontend
  // This works for both Preview and Live deployments
  return window.location.origin;
};

export const BACKEND_URL = getBackendUrl();

// Feature flags. Flip to `true` and redeploy to ship the feature.
// Kept here (not in .env) so toggling doesn't need an env-var redeploy and
// the value is identical across preview and prod.
export const FEATURE_FLAGS = {
  // Experience Montreal blog/perks page is still under construction. While
  // false: header CTA hides, welcome-page block hides, /experience-montreal
  // route shows a "Coming soon" placeholder.
  experienceMontreal: false,
  // OTA-referral model: stays are booked on partner sites (Booking.com,
  // Agoda, Vrbo, Trip.com). While false, the direct Stripe checkout is
  // replaced by partner deep links everywhere.
  directBooking: false,
};

/**
 * Fetch the active Stripe publishable key from the backend.
 *
 * The key follows whatever the deployed environment uses — preview env runs
 * in test mode, prod runs in live mode. We fetch lazily and cache the
 * promise so repeated calls (RequestToBookModal, PaymentModal) share a
 * single network round-trip.
 *
 * Falls back to `process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY` only when
 * the backend isn't reachable (e.g. local dev without a running API).
 */
let _stripeKeyPromise = null;
export function getStripePublishableKey() {
  if (_stripeKeyPromise) return _stripeKeyPromise;
  _stripeKeyPromise = (async () => {
    try {
      const r = await fetch(`${BACKEND_URL}/api/payments/publishable-key`);
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const data = await r.json();
      if (data?.publishable_key) return data.publishable_key;
    } catch (e) {
      // fall through to env fallback
    }
    return process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';
  })();
  return _stripeKeyPromise;
}

// Legacy export — only the build-time env var. Prefer `getStripePublishableKey()`.
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

// Mapbox token must come from the env var. Deploy checks reject any
// hardcoded secret fallback in source.
export const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN || '';

if (!MAPBOX_TOKEN) {
  console.warn('REACT_APP_MAPBOX_TOKEN is not set — map rendering will be disabled.');
}
